module.exports = __webpack_public_path__ + "img/main-gallery6-mob.fd557495.webp";